module.exports = __webpack_public_path__ + "img/9791195764891.a3066539.jpg";